exports.increaseCartItemCounter = function increaseCartItemCounter() {
  const cartItemCounter = document.getElementById('cs-header__cartCounter');
  cartItemCounter.innerText = parseInt(cartItemCounter.innerText) + 1;
}

exports.shakeElementByID = function shakeElementByID(elementID) {
  const inputField = document.getElementById(elementID);
  inputField.classList.add("errorBounce");
  setTimeout(function() {
    inputField.classList.remove("errorBounce");
  }, 1000);
}

exports.shakeElementsByClass = function shakeElementsByClass(className){
  const inputFields=document.getElementsByClassName(className);
  for(let index=0;index<inputFields.length;index++) {
    inputFields[index].classList.add("errorBounce");
  }
  setTimeout(function() {
    for(let index=0;index<inputFields.length;index++) {
      inputFields[index].classList.remove("errorBounce");
    }
  }, 1000);
}